// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3SBDE","title":"style_title__1T3JV","barWrap":"style_barWrap__3rMJ5","bar":"style_bar__nDLGV","isVisible":"style_isVisible__2i0b1","value":"style_value__2K9rh"};